import { USPCard, USPCardProps } from "@@/components/Card/USP";
import Box from "@@/elements/Box";
import Container from "@@/elements/Container";
import Typography from "@@/elements/Typography";
import OptimizelyBlock, {
  OptimizelyBlockProps,
} from "@@/integrations/optimizly/Block";
import EpiProperty from "@@/integrations/optimizly/Property";
import cn from "classnames";
import styles from "./index.module.scss";

type IconColors =  "green" | "blue" | "beige";
type BackgroundColors = "white" | "green" | "blue" | "beige";

type USPCardsProperties = {
  header?: string;
  intro?: string;
  backgroundColor: BackgroundColors;
  iconColor?: IconColors;
  cards: USPCardProps[];
};

type USPCardsOwnProps = {
  anchorId?: string;
};

export type USPCardsProps = USPCardsOwnProps &
  USPCardsProperties;

export const getColor = (color: BackgroundColors ) => {
  switch (color) {
  case "green":
    return "PrimaryGreenTint03";
  case "blue":
    return "PrimaryBlueTint03";
  case "beige":
    return "ComplementaryBeigeTint03";
  case "white":
    return "White";
  default:
    return "ComplementaryBeigeTint03";
  }
};

const USPCards = ({ header, intro, backgroundColor, iconColor, cards, anchorId }: USPCardsProps) => {
 
  const cardsClasses = cn(
    styles.cards_wrapper, styles[`cards_wrapper_${cards.length}`]);

  return (
    <Container
      id={anchorId}
      size={"full"}
      pageGutter={0}
      component="section"
      backgroundColor={getColor(backgroundColor)} >
      <Container>
        <EpiProperty<USPCardsProperties> name="header">
          <Typography
            textAlign="center"
            mb={intro ? 8 : 0}
            variant="heading2">{header}</Typography>
        </EpiProperty>
        <EpiProperty<USPCardsProperties> name="intro">
          <Typography
            textAlign="center"
            variant="intro">{intro}</Typography>
        </EpiProperty>
        <EpiProperty<USPCardsProperties>
          name="cards">
          <Box
            mt={12}
            className={cardsClasses}>  
            {cards?.map((card, index) => (
              <USPCard
                key={index}
                iconColor={backgroundColor !== "white" ? "white" : iconColor} 
                borderColor={backgroundColor === undefined ? "beige" : backgroundColor}
                {...card}       
              />
            ))}
          </Box>
        </EpiProperty>
      </Container>
    </Container>
  );
};

export type ProvidedUSPCardsProps = OptimizelyBlockProps<USPCardsProperties> & USPCardsProps;

const ProvidedUSPCards = ({
  blockId,
  inEditMode,
  properties,
  anchorId,
  ...rest
}: ProvidedUSPCardsProps) => {
  return (
    <OptimizelyBlock
      blockId={blockId}
      inEditMode={inEditMode}
      properties={properties}
      anchorId={anchorId}
    >
      {(optimizlyProperties) => <USPCards
        anchorId={anchorId}
        {...rest}
        {...optimizlyProperties} />}
    </OptimizelyBlock>
  );
};

export default ProvidedUSPCards;